import React from 'react';
import {useDraggable} from '@dnd-kit/core';
import { CSS } from "@dnd-kit/utilities";

// eslint-disable-next-line react/prop-types
export function Draggable({ children }) {
    console.log("children",children);
  const {attributes, listeners, setNodeRef, transform} = useDraggable({
    id: children,
    data: { title: children }
  });
  const style = transform ? {
    transform: `translate3d(${transform.x}px, ${transform.y}px, 0)`,
  } : undefined;

  
  return (
    <button ref={setNodeRef} style={{ transform: CSS.Translate.toString(transform) }} {...listeners} {...attributes}>
      {children}
    </button>
  );
}

